export default class GroupPermissionsBuilder {
  build(groupPermissionsMap) {
    const groupPermissionList = []

    _.forEach(Object.keys(groupPermissionsMap), groupPermissionTitle => {
      const permissions = []

      _.forEach(groupPermissionsMap[groupPermissionTitle], permission => {
        permission.group_permission_title = groupPermissionTitle
        permissions.push(permission)
      })

      groupPermissionList.push({
        title: groupPermissionTitle,
        permissions: permissions,
      })
    })

    return groupPermissionList
  }
}
